<div [formGroup]="item" class="order-entry-container">
  <div class="order-entry-form">
    <div class="oder-entry-form-line" fxLayout="row" fxLayoutGap="10px">
      <input type="hidden" formControlName="id">
      <mat-form-field fxFlex>
        <input type="text" placeholder="Project" matInput formControlName="budget" [matAutocomplete]="autoBudget">
        <mat-autocomplete #autoBudget="matAutocomplete" [displayWith]="budgetDisplayFn" (optionSelected)="budgetChange($event)">
          <mat-option *ngFor="let budget of filteredBudgets | async" [value]="budget">
            <span *ngIf="budget.project">{{ budget | projectNr }}-</span>{{ budget.budgetNr }}
            <small *ngIf="budget.companyName">{{ budget.companyName }}</small>
            <small *ngIf="budget.prosperworks && budget.prosperworks.company_name">{{ budget.prosperworks.company_name }}</small>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="oder-entry-form-line" fxLayout="row" fxLayoutGap="10px">

      <mat-form-field fxFlex>
        <mat-select placeholder="Sub Budget" (selectionChange)="setUpdateValues()" formControlName="subBudget" [compareWith]="compareSubBudget" i18n-placeholder>
          <mat-option *ngFor="let subbudget of subbudgets | async" [value]="subbudget">
            {{ subbudget.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="1 0">
        <mat-select placeholder="Material" (selectionChange)="setUpdateValues()" formControlName="material" [compareWith]="compareMaterial" i18n-placeholder>
          <mat-option *ngFor="let material of materials | async" [value]="material">
            {{ material.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex>
        <input matInput placeholder="Code" type="text" class="form-control" [attr.id]="'description'+index" formControlName="code" i18n-placeholder>
      </mat-form-field>
      <mat-form-field fxFlex="0 0 80px">
        <mat-select placeholder="Unit" formControlName="unit" name="unit" i18n-placeholder>
          <mat-option *ngFor="let u of unities" [value]="u">
            {{ u }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="0 0 100px">
        <input matInput placeholder="Quantity" type="number" class="form-control" [attr.id]="'quantity'+index" formControlName="quantity" i18n-placeholder>
      </mat-form-field>
      <mat-form-field fxFlex="0 0 100px">
        <input matInput placeholder="Price per unit" type="number" class="form-control" [attr.id]="'costEach'+index" formControlName="costEach" i18n-placeholder>
      </mat-form-field>
      <mat-form-field fxFlex="0 0 100px">
        <input matInput placeholder="Discount" type="number" class="form-control" [attr.id]="'discount'+index" formControlName="discount" i18n-placeholder>
      </mat-form-field>
      <div fxFlex>
        <span class="entry-total-value">{{ total | currency:'EUR' }}</span>
      </div>
    </div>
    <div class="oder-entry-form-line" fxLayout="row">
      <mat-form-field fxFlex>
        <textarea matInput matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="10" placeholder="Description" class="form-control" [attr.id]="'description'+index" formControlName="description" i18n-placeholder></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="order-entry-remove-button" *ngIf="!isInvoicesAndDdt">
    <button mat-button type="button" class="btn" (click)="removed.emit(index)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/order/components/order-entry.component.html